export const TARGET_ILIAS_APP = 'asasqt_portal';

export const authorizationHookTranslations = (tr: any) => {
  return {
    Error_LoginFailed: tr('common.error.loginError'),
    Error_ServerIssue: tr('common.error.server'),
    Error_InvalidLoginData: tr('common.error.invalidLoginData'),
  };
};
